var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo__src",attrs:{"src":require("@/assets/imgs/logo.svg")}}),(_vm.text)?_c('div',{staticClass:"logo__text"},[_vm._v("braingineers")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }